import axios from "axios";

export default {
    data() {
        return {
                //Timer
       TimerObject: {}
        }
    },

    methods: {
      visitChange(){
      this.visitRList = [];
      if(this.selectedVisitT.length > 0){
       for(var k=0;k<this.selectedVisitT.length;k++){
         for(var m=0;m<this.visitReason_1.length;m++){
         if(this.selectedVisitT[k].visitTypeId == this.visitReason_1[m].visitTypeId){
          this.visitRList.push(this.visitReason_1[m]);
         }
        }
       }
      }
      else {
         this.selectedVisitT = [];
         this.visitRList = []; 
        }

        if(this.selectedVisitT.length > 0){
          this.reasonD = true;
        } else { this.reasonD = false; }
      this.fetchInitData();
     },
     visitReasonChange(){
      this.fetchInitData();
     },
        SearchDataTable() {
            this.visitName = this.searchFilter.toLowerCase();
            if(this.visitName !== "") { 
              this.fetchInitData();
            } else this.fetchInitData();
           },
        datePickerPR() {
            const self = this;
            $('input[name="daterangePR"]').daterangepicker(
                {
                    opens: "left",
                },
                function (start, end) {
                    self.startDatePR = new Date(start);
                    self.endDatePR = new Date(end);
                    self.initDatePR =
                        self.dateToMDY(self.startDatePR) +
                        " - " +
                        self.dateToMDY(self.endDatePR);
                }
            );
        },
  //code for Data-Tables_
  pageChange(obj) {
    if (obj == "Next") {
      if (this.pageNumber < this.totalPages) {
        this.pageNumber += 1;
      }
    } else if (obj == "Previous" && this.pageNumber != 1) {
      this.pageNumber -= 1;
    } else {
      this.pageNumber = obj;
    }
    //show pagination
    if((this.showPagesMax/2) < (this.pageNumber))
    {
      this.showPagesMin = this.pageNumber-4;
      this.showPagesMax = this.pageNumber+4;
    }
    else if((this.showPagesMin/2)<(this.pageNumber))
    {
      this.showPagesMin = this.pageNumber-4;
      this.showPagesMax = this.pageNumber+4 ;
      if(this.showPagesMax<5)
      {
        this.showPagesMax = 5;
      }
    }
    else{
      this.showPagesMin = 1;
      this.showPagesMax = 5 ;
    }
     //show pagination
    this.fetchInitData();
  },
  orderBy(column) {
    if (this.sortColumn == column) {
      switch (this.sortColumnOption) {
        case 0:
          this.sortColumnOption = 1;
          break;
        case 1:
          this.sortColumnOption = 2;
          break;
        case 2:
          this.sortColumn = 0;
          this.sortColumnOption = 0;
          break;
      }
    } else {
      this.sortColumn = column;
      this.sortColumnOption = 1;
    }
    this.pageNumber = 1;
    this.fetchInitData();
  },
  //Timer
  StartLogoutTime() {
    this.TimerObject = setTimeout(() => {
      this.AutoLogout();
    }, this.LogoutTime);
  },
  ResetLogoutTime() {
    clearTimeout(this.TimerObject);
    this.TimerObject = setTimeout(() => {
      this.AutoLogout();
    }, this.LogoutTime);
  },

        loadInit() {
            const dd = new Date();
            dd.setDate(dd.getDate() - 30);

            this.startDatePR = dd;
            this.endDatePR = new Date();
            this.initDatePR =
                this.dateToMDY(this.startDatePR) +
                " - " +
                this.dateToMDY(this.endDatePR);

            this.fetchInitData();
            this.StartLogoutTime();
        },
        getVisitReason(){
          this.intDummyComm();
          this.dummyComm.filter = "";
            
          const filter = {
              veinsId: "",
              externalId: "",
              firstName: this.visitName,
              lastName: "",
              phone: "",
              startDate: "",
              endDate: ""
            };
      
          const myData = {
            dc: this.dummyComm,
            filter: filter,
            sortColumn: this.sortColumn,
            sortColumnOption: this.sortColumnOption,
          };

          const url = this.SERVER + "/VNSPRAAPI/Reports/VisitTypeReason";
          this.axiosGetData(url, 2, myData);
        },

        fetchInitData() {
            this.intDummyComm();
            
            //visitType & R
            if (this.selectedVisitT.length > 0) {
               let aa = [];
              for (let i = 0; i < this.selectedVisitT.length; i++)
               aa.push(this.selectedVisitT[i].visitTypeId);
               this.visitTypeVa = aa.toString();
          }
          if (this.selectedVisitR.length > 0) {
               let aa1 = [];
            for (let i = 0; i < this.selectedVisitR.length; i++)
            aa1.push(this.selectedVisitR[i].visitDetailId);
            this.visitRVal = aa1.toString();
          }
            if (this.initDatePR.length > 0) {
                this.dummyComm.myDate = this.dateToSqlServerDateFormat(
                    this.startDatePR
                );
                this.dummyComm.myTime = this.dateToSqlServerDateFormat(this.endDatePR);
            } else {
                this.dummyComm.myDate = null;
                this.dummyComm.myTime = null;
            }

            this.dummyComm.pageNumber = this.pageNumber;
            this.dummyComm.pageSize = this.pageSize;
            this.dummyComm.filter = "";
            
            const filter = {
                visitType: this.visitTypeVa,
                visitReason: this.visitRVal,
                veinsId: "",
                externalId: "",
                firstName: this.visitName,
                lastName: "",
                phone: "",
                startDate: "",
                endDate: ""
              };
        
            const myData = {
              dc: this.dummyComm,
              filter: filter,
              sortColumn: this.sortColumn,
              sortColumnOption: this.sortColumnOption,
            };

            const url = this.SERVER + "/VNSPRAAPI/Reports/VisitReportInitData";
            this.axiosGetData(url, 1, myData);
        },

        //------------------------------------------ Common Methods
        async axiosGetData(myUrl, what, myData) {
            var loader = this.$loading.show({
                // Optional parameters
                  color: '#03a9f3'
                });
            await axios({
                method: "post",
                url: myUrl,
                data: myData, headers:{
          Authorization: this.$store.getters.getAuthToken,
        }
            })
                .then((res) => {
                    loader.hide();
                    // if everything goes well -- we will get data
                    this.lastErrorCode = 1;
                    if (what === 1) {
                       //debugger
                        this.totalRows = res.data.dc.totalRow;
                        this.totalPages = res.data.dc.totalPages;
                        this.vData = res.data.outData;
                        this.visitRVal = "";
                        this.visitTypeVa = "";
                    }
                    if (what === 2) {
                      this.visitType = res.data.visitType;
                      this.visitReason_1 = res.data.visitDetail;
                  }
                })
                .catch(function (error) {
                    if (error.response) {
                        this.lastErrorCode = 1;
                        alert("-> " + error.response.data);
                        alert("-> " + error.response.status);
                        alert("-> " + error.response.headers);
                    } else if (error.request) {
                        this.lastErrorCode = 1;
                        alert("No response " + error.request);
                    } else {
                        this.lastErrorCode = 1;
                        alert("Error", error.message);
                    }
                })
                .finally(() => {
                    this.ResetLogoutTime();
                    loader.hide();
                 });
        }, // axiosGetData

    }, // end methods

    watch: {
        initDatePR: function () {
            this.pageNumber = 1;
            this.fetchInitData();
        },

        vData: function () {
            let obj = this.vData;
            let kount = 0;
            for (let i = 0; i < obj.length; i++) {
                kount += obj[i].totalVisits;
            }
            for (let i = 0; i < obj.length; i++) {
                obj[i].percentage = ((obj[i].totalVisits / kount) * 100).toFixed(1);
            }
        },

    }, // watch
    mounted(){
      if(this.$store.getters.getAuthToken==="")
    {
        this.$store.commit('setAuthToken',localStorage.BeToken);
    }
        this.loadInit();
    },
    unmounted() {
        clearTimeout(this.TimerObject);
      },
}